export const targetingSites = {
  uk: `heycar UK`,
  fr: `heycar FR`,
  rac: `RAC Cars`,
};
